import { Center, Heading, Spinner, VStack } from '@chakra-ui/react'
import { SidebarNestedNavList, SidebarNestedNavListSection } from '@src/components/sco/SidebarNestedNavList'
import { useCurrentUser } from '@src/hooks/useCurrentUser'
import React from 'react'
import { LuBriefcase, LuHammer, LuHand, LuRocket, LuUser } from 'react-icons/lu'

type OnboardingNavProps = {}

export const matchingSignupNavItems: SidebarNestedNavListSection[] = [
  {
    title: 'Create Account',
    icon: () => <LuHand />,
    href: `/members/matching/signup/register`,
  },
  {
    title: 'Personal Profile',
    icon: () => <LuUser />,
    href: `/members/matching/signup/profile`,
  },
  {
    title: 'Skills & Experiences',
    icon: () => <LuHammer />,
    href: `/members/matching/signup/skills`,
  },
  {
    title: 'Startup Profile',
    icon: () => <LuBriefcase />,
    href: `/members/matching/signup/startup`,
  },
  {
    title: 'Get Involved',
    icon: () => <LuRocket />,
    href: `/members/matching/signup/get-involved`,
  },
].filter(Boolean)

export const MatchingSignupNav = (props: OnboardingNavProps) => {
  const { currentUser } = useCurrentUser()

  if (!currentUser) {
    return (
      <Center paddingY={'10em'}>
        <Spinner />
      </Center>
    )
  }

  return (
    <VStack align={'stretch'} gap={0} paddingX={'1em'} width={'full'}>
      <Heading margin={0} paddingY={'1.5em'} size={'sm'}>
        Join Member Matching
      </Heading>
      <SidebarNestedNavList sections={matchingSignupNavItems} />
    </VStack>
  )
}
